export default __webpack_public_path__ + "static/media/en.e1a8d29e.svg";